import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { TAIGA_UI_MODULES } from 'app/@taiga-modules';
import {TuiScrollbar} from '@taiga-ui/core';
import { selectComments } from 'app/widget/state';

@Component({
  selector: 'app-comments',
  standalone: true,
  imports: [...TAIGA_UI_MODULES, CommonModule, TuiScrollbar],
  templateUrl: './comments.component.html',
  styleUrl: './comments.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentsComponent { 
  index = 0

  store$ = inject(Store);
  selectComments$ = this.store$.select(selectComments)
}
